exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3c231aef]:export {\n  primary: #aa4121;\n  secondary: #ccc;\n  gray: #636363;\n}\n.max-height-responsive[data-v-3c231aef] {\n  max-height: 500px;\n}\n.custom-border[data-v-3c231aef] {\n  border: solid 1px #c2c0c0;\n}", ""]);

// exports
